function animateCounter(id, end, duration, suffix = '') {
    const element = document.getElementById(id);
    let startTime = null;
    let start = 0;

    function step(timestamp) {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        element.textContent = Math.floor(progress * (end - start) + start) + suffix;
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    }

    window.requestAnimationFrame(step);
}

document.addEventListener('DOMContentLoaded', () => {
    const counters = [
        { id: 'count1', end: 2500, duration: 1500, suffix: '+' },
        { id: 'count2', end: 3, duration: 1500, suffix: '+' },
        { id: 'count3', end: 90, duration: 1500, suffix: '%' }
    ];

    counters.forEach(counter => {
        const element = document.getElementById(counter.id);
        if (element) {
            // Initialize the counter display
            element.textContent = '0' + counter.suffix;
        } else {
            console.warn(`Element with id ${counter.id} not found`);
        }
    });

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const counter = counters.find(c => c.id === entry.target.id);
                if (counter) {
                    animateCounter(counter.id, counter.end, counter.duration, counter.suffix);
                    observer.unobserve(entry.target); // Stop observing once animated
                }
            }
        });
    });

    counters.forEach(counter => {
        const element = document.getElementById(counter.id);
        if (element) {
            observer.observe(element);
        }
    });
});
